// extracted by mini-css-extract-plugin
module.exports = {"lineHeight1":"QQLink_lineHeight1__zkY9y"};